export const PRODUCT_TYPES = ['h-basic']
